import { useEffect, useState } from "react";
import { api } from "../api";

const fmt = (b) => (b >= 1073741824 ? `${(b / 1073741824).toFixed(1)} GB` : `${(b / 1048576).toFixed(0)} MB`);

export function StorageUsage() {
  const [u, setU] = useState(null);
  useEffect(() => { api.get("/pam-drive/usage").then(({ data }) => setU(data)).catch(() => {}); }, []);
  if (!u) return null;
  const pct = Math.min(100, Math.round((u.active_used_bytes / (u.quota_bytes || 1)) * 100));
  return (
    <div className="yp-card p-4 mb-5" data-testid="storage-usage">
      <div className="flex items-center justify-between text-sm mb-1.5">
        <span className="font-semibold text-slate-700">Spazio PAM Drive</span>
        <span className="text-slate-500" data-testid="storage-usage-text">{fmt(u.active_used_bytes)} di {fmt(u.quota_bytes)} utilizzati</span>
      </div>
      <div className="h-2.5 rounded-full bg-slate-200 overflow-hidden">
        <div className={`h-full transition-all ${u.is_over_quota ? "bg-red-500" : "bg-blue-500"}`} style={{ width: `${pct}%` }} data-testid="storage-usage-bar" />
      </div>
      {u.is_over_quota && <div className="mt-1.5 text-xs font-semibold text-red-600" data-testid="storage-over-quota">Spazio esaurito</div>}
    </div>
  );
}
